import { rankOf, type CardId } from '@basgan/rules';
import type { ViewMessage } from '@basgan/protocol';

/**
 * Elde bir karta dokunmanın sonucu.
 *
 * Kilit gözlem: `legalMoves` zaten "hangi rütbeden kaç tane atılabilir"i
 * içeriyor. Takipçi konumunda turun kart sayısı sabit olduğu için her rütbeye
 * karşılık TEK bir hamle var → dokunmak doğrudan oynar, onay düğmesi gereksiz.
 * Lider konumunda ise aynı rütbeden 1/2/3/4 atılabilir → sayı sorulur.
 *
 * Yani "ne zaman soralım" sorusunu ayrıca hesaplamıyoruz; seçenek sayısından
 * kendiliğinden çıkıyor.
 */
export type TapResult =
  | { kind: 'play'; cards: CardId[] }
  | { kind: 'choose'; options: CardId[][] }
  | { kind: 'none' };

export function resolveTap(view: ViewMessage, card: CardId): TapResult {
  if (view.phase !== 'play' || view.turn !== view.you) return { kind: 'none' };

  const rank = rankOf(card);
  const options = view.legalMoves
    .filter((m) => m.type === 'play' && rankOf(m.cards[0]!) === rank)
    .map((m) => (m.type === 'play' ? m.cards : []));

  if (options.length === 0) return { kind: 'none' };
  if (options.length === 1) return { kind: 'play', cards: options[0]! };
  return { kind: 'choose', options };
}

/** Bu rütbeden en az bir hamle var mı — kartı yukarı kaldırmak için. */
export function isPlayable(view: ViewMessage, card: CardId): boolean {
  return resolveTap(view, card).kind !== 'none';
}
